import apiConfig from "../../apiConfig";

export const getLicenseForbiddenNamesList = async (at) => {
	const response = await apiConfig.post(
		"/API/ADMINISTRATION/LICENSES/NAMES/Get_Licenses_Forbidden_Names_List",
		{
			PageSize: 100000,
			PageIndex: 1
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	if (response.data.Status) {
		return response.data.Data;
	}
	return [];
};
